import { useEditMode } from '@/context/EditModeContext';
import { Pencil, X, Info } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function EditBanner() {
  const { editMode, canEdit, toggle } = useEditMode();
  if (!canEdit || !editMode) return null;
  return (
    <div className="sticky top-0 z-[60] bg-gradient-to-r from-royal via-royal-dark to-royal text-white shadow-lg border-b-2 border-gold">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-xs sm:text-sm">
          <Pencil className="w-4 h-4 text-gold" />
          <span className="font-semibold">Editing Mode</span>
          <span className="hidden sm:inline text-white/80 flex items-center gap-1">
            <Info className="w-3 h-3" /> Click any highlighted text or image to edit it.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/admin" className="text-xs text-gold hover:underline">Advanced CMS</Link>
          <button
            onClick={toggle}
            data-testid="exit-edit-mode-btn"
            className="inline-flex items-center gap-1 text-xs bg-white/10 hover:bg-white/20 border border-white/30 px-3 py-1 rounded-full"
          >
            <X className="w-3 h-3" /> Exit Edit Mode
          </button>
        </div>
      </div>
    </div>
  );
}
